import { ReactElement, useMemo } from 'react';

import LoadingFallback from '~components/LoadingFallback';

import { DashboardVariantV2CarrierContentInTransitTabTrackingContainer } from './styles';

import DashboardVariantV2CarrierContentInTransitTrackingProvider, {
  useDashboardVariantV2CarrierContentInTransitTrackingContext,
} from './Context';
import DashboardVariantV2CarrierContentInTransitTabTrackingSelection from './Selection';
import DashboardVariantV2CarrierContentInTransitTabTrackingMap from './Map';

const DashboardVariantV2CarrierContentInTransitTabTracking =
  (): ReactElement => {
    const {
      tabsData: { isFirstRequest: isFirstRequestTabData },
      mapData: { isFirstRequest: isFirstRequestMapData },
    } = useDashboardVariantV2CarrierContentInTransitTrackingContext();

    const initialLoading = useMemo(
      () => isFirstRequestTabData || isFirstRequestMapData,
      [isFirstRequestTabData, isFirstRequestMapData],
    );

    return (
      <DashboardVariantV2CarrierContentInTransitTabTrackingContainer>
        {initialLoading && <LoadingFallback />}

        {!initialLoading && (
          <>
            <DashboardVariantV2CarrierContentInTransitTabTrackingSelection />

            <DashboardVariantV2CarrierContentInTransitTabTrackingMap />
          </>
        )}
      </DashboardVariantV2CarrierContentInTransitTabTrackingContainer>
    );
  };

const DashboardVariantV2CarrierContentInTransitTabTrackingWrapper =
  (): ReactElement => (
    <DashboardVariantV2CarrierContentInTransitTrackingProvider>
      <DashboardVariantV2CarrierContentInTransitTabTracking />
    </DashboardVariantV2CarrierContentInTransitTrackingProvider>
  );

export default DashboardVariantV2CarrierContentInTransitTabTrackingWrapper;
